import styled from "styled-components";
import { useIsMedia } from "src/apps/hooks/useIsMedia";
import { OrderIdentityVerification } from "src/contexts/documentationArea/domain/OrderIdentityVerification";
import { T } from "src/apps/components/i18n/Translation";
import { IDVOrderBoxHeaderIcon } from "./IDVOrderBoxHeaderIcon";
import { IdentityVerificationDocumentSides } from "src/contexts/identityVerification/domain/IdentityVerificationDocumentSides";

interface OrderBoxHeaderProps {
  order: OrderIdentityVerification;
  side: IdentityVerificationDocumentSides;
}

export const IDVOrderBoxHeader = ({ order, side }: OrderBoxHeaderProps) => {
  const { isMobile } = useIsMedia();

  return (
    <HeaderContainer>
      <FirstRow>
        {!isMobile ? <IDVOrderBoxHeaderIcon order={order} side={side} /> : null}
        <TitleContainer>
          <T
            k={
              side === "front"
                ? "documentation_area.identity_verification.uploader_title.front"
                : "documentation_area.identity_verification.uploader_title.back"
            }
          />
        </TitleContainer>
      </FirstRow>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  font-weight: bold;
  gap: 0.375rem;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

const FirstRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
  align-items: center;
`;
